/* global axios */
import ApiClient from './ApiClient';

class ServiceOrdersAPI extends ApiClient {
  constructor() {
    super('service_orders', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  update(id, orderData) {
    return axios.patch(`${this.url}/${id}`, { service_order: orderData });
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  merge(primaryId, childOrderIds) {
    return axios.post(`${this.url}/${primaryId}/merge`, {
      child_order_ids: childOrderIds,
    });
  }

  redirect(orderId, data) {
    return axios.post(`${this.url}/${orderId}/redirect`, data);
  }

  linkTicket(orderId, ticketId) {
    return axios.post(`${this.url}/${orderId}/link_ticket`, {
      ticket_id: ticketId,
    });
  }

  unlinkTicket(orderId, ticketId) {
    return axios.delete(`${this.url}/${orderId}/unlink_ticket`, {
      params: { ticket_id: ticketId },
    });
  }

  reportStats(params = {}) {
    return axios.get(`${this.url}/report_stats`, { params });
  }
}

export default new ServiceOrdersAPI();
